<p-dialog
  appendTo="body"
  [(visible)]="config.display"
  modal="true"
  [closable]="true"
  [draggable]="false"
  [header]="config.headerTitle"
  [dismissableMask]="false"
  [style]="config.dialogStyle"
  (onHide)="handleClose()">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <p-button icon="pi pi-pencil" [rounded]="true" severity="secondary"></p-button>
      <span class="font-bold white-space-nowrap" style="font-size: 14px !important; padding-left: 15px">
        {{ config.headerTitle | translate }}
      </span>
    </div>
  </ng-template>

  <div class="dialog-content" [ngStyle]="config.contentStyle">
    <p [innerHtml]="config.content | translate"></p>
    @if (config.link) {
      <p class="api-link">
        <span [ngStyle]="config.linkLabelStyle">
          @if (!config.linkContent.icon) {
            {{ config.linkLabel | translate }}
            <a [href]="config.linkContent.href" target="_blank" [ngStyle]="config.linkContentStyle">{{
              config.linkContent.text | translate
            }}</a>
          } @else {
            <div style="display: flex; align-items: center; gap: 10px" class="iconSection">
              <span>{{ config.linkLabel | translate }}</span>
              <p-button
                [ngStyle]="config.buttonStyle"
                [icon]="config.linkContent.iconButton.icon"
                [text]="true"
                [severity]="config.linkContent.iconButton.severity"
                iconPos="right"
                ngxClipboard
                [cbContent]="config.linkLabel"
                #copyButton
                (click)="toggleTooltip()"
                [pTooltip]="showTooltip ? 'copiée  &#10003;' : null"
                [tooltipPosition]="'right'"
                tooltipEvent="focus">
              </p-button>
            </div>
          }
        </span>
      </p>
    }
    @if (config.additionnalText) {
      <div [ngStyle]="config.additionnalTextStyle" [innerHTML]="config.additionnalTextContent | translate"></div>
    }
  </div>
  @if (config.showFooter) {
    <ng-template pTemplate="footer">
      <ng-container *ngFor="let button of config.footerButtons">
        <p-button
          [icon]="button.icon"
          [label]="button.label | translate"
          [severity]="button.severity"
          (onClick)="button.action()"
          [outlined]="true"
          [ngStyle]="config.buttonStyle">
        </p-button>
      </ng-container>
    </ng-template>
  }
</p-dialog>
